// extracted by mini-css-extract-plugin
module.exports = {"links":"styles_links__Yv3Lx","image":"styles_image__ZnC8P","link":"styles_link__bbsKY"};